export default "__VITE_ASSET__CnDtNec7__"